import { tabKeys, } from './Constants';
import CustomerProfileView from '../components/view/CustomerProfile/CustomerProfile';
import UpdateUsernameView from '../components/view/UpdateUsername';
import RemoveUserView from '../components/view/RemoveUser';
import CopyDocumentsView from '../components/view/CopyDocuments';
import ConversationViewer from '../components/view/ConversationViewer/ConversationViewer';
import EncryptDecrypt from '../components/view/EncryptDecrypt';
import TransactionSearchView from '../components/view/transactionsearch/TransactionSearch';
import ScheduledTransactionView from '../components/view/ScheduledTransactionSearch/ScheduledTransactionSearch';
import ManagedPayView from '../components/view/ManagedPay/ManagedPay';
import BulkGenResolveView from '../components/view/GenResolve/BulkGenResolveView';
import AutopayView from '../components/view/Autopay/Autopay';
import AutopayStatus from '../components/view/AutopayStatus';
import SendEmailView from '../components/view/SendEmail';

import RefundView from '../components/view/refund/component/RefundView';
import ServiceManagement from '../components/view/ServiceManagement/ServiceManagement';
import NcDmv from '../components/view/ServiceManagement/ServiceViews/NCDMV/NcDmv';
import KsDmv from '../components/view/ServiceManagement/ServiceViews/KSDMV/KsDmv';
import KsDl from '../components/view/ServiceManagement/ServiceViews/KSDL/KsDl';
import KsDLCoA from '../components/view/ServiceManagement/ServiceViews/KSDLCOA/KsDLCoA';
import GRWater from '../components/view/ServiceManagement/ServiceViews/GRWater/GRWater';
import GRWaterV2 from '../components/view/Water/GrAdapter';
import GRRefuse from '../components/view/ServiceManagement/ServiceViews/GRRefuse/GRRefuse';
import Beaufort from '../components/view/ServiceManagement/ServiceViews/Beaufort/Beaufort';
import KCKTax from '../components/view/ServiceManagement/ServiceViews/KCKTax/KCKTax';
import KCKTaxPersonal from '../components/view/ServiceManagement/ServiceViews/KCKTaxPersonal/KCKTaxPersonal';
import GRParking from '../components/view/ServiceManagement/ServiceViews/GRParking/GRParking';
import Jackson from '../components/view/ServiceManagement/ServiceViews/Jackson/Jackson';
import Shelby from '../components/view/ServiceManagement/ServiceViews/Shelby/Shelby';
import STLProperty from '../components/view/ServiceManagement/ServiceViews/STLProperty/STLProperty';
import STLWater from '../components/view/ServiceManagement/ServiceViews/STLWater/STLWater';
import STLRealEstate from '../components/view/ServiceManagement/ServiceViews/STLRealEstate/STLRealEstate';
import GRPropertyTax from '../components/view/ServiceManagement/ServiceViews/GRPropertyTax/GRPropertyTax';
import GRBlockGrants from '../components/view/ServiceManagement/ServiceViews/GRBlockGrants/GRBlockGrants';
import FlDmv from '../components/view/ServiceManagement/ServiceViews/FlDmv/FlDmv';

import ServiceFee from '../components/view/ServiceFee/ServiceFee';
import EbillCustomerView from '../components/view/Ebill/EbillCustomerView';
import EbillSend from '../components/view/Ebill/EbillSend';
import EbillTrialSend from '../components/view/Ebill/EbillTrialSend';
import BeaufortUnenrollment from '../components/view/ManualProcesses/BeaufortUnenrollment';
import NcDl from '../components/view/ServiceManagement/ServiceViews/NCDL/NcDl';
import NcDmvDrivingRecord from '../components/view/ServiceManagement/ServiceViews/NcDmvDrivingRecord/NcDmvDrivingRecord';
import NcDmvHearingFee from '../components/view/ServiceManagement/ServiceViews/NcDmvHearingFee/NcDmvHearingFee';
import NcDmvHandicapPlacard from '../components/view/ServiceManagement/ServiceViews/NcDmvHandicapPlacard/NcDmvHandicapPlacard';
import NcIdentityVerification from '../components/view/ServiceManagement/ServiceViews/NcIdentityVerification/NcIdentityVerification';
import NcDmvDrivewayPermits from '../components/view/ServiceManagement/ServiceViews/NcDmvDrivewayPermits/NcDmvDrivewayPermits';
import NcDmvCrashReports from '../components/view/ServiceManagement/ServiceViews/NcDmvCrashReports/NcDmvCrashReports';
import NcHFAHS from '../components/view/ServiceManagement/ServiceViews/NcHFAHS/NcHFAHS';
import NcCPAHS from '../components/view/ServiceManagement/ServiceViews/NcCPAHS/NcCPAHS';
import BatchPay from '../components/view/ManualProcesses/BatchPay';
import IVR from '../components/view/ServiceManagement/ServiceViews/IVR/IVR';
import OkDmv from '../components/view/ServiceManagement/ServiceViews/OKDMV/OkDmv';
import AVSWhitelist from '../components/view/PaymentAccount/AVSWhitelist';
import EbillingView from '../components/view/Ebilling/Ebilling';
import NcInsuranceLapse from '../components/view/ServiceManagement/ServiceViews/NcInsuranceLapse/NcInsuranceLapse';
import NcHFLites from '../components/view/ServiceManagement/ServiceViews/NcHFLites/NcHFLites';
import PRSView from '../components/view/PayableReminder/PRSView';
import SMSSearchView from '../components/view/SMSSearch/SMSSearch';
import CommunicationPreferencesView from '../components/view/CommunicationPreferences/CommunicationPreferences';
import FailedQueueItemSearchView from '../components/view/DurableQueue/FailedQueueItemSearchView';
import LinkedCustomersView from '../components/view/LinkedCustomers/LinkedCustomers';
import UnenrollSamlUsersView from '../components/view/ConvertSamlUsers/ConvertSamlUsers';
import BulkRefundJSONGeneratorView from '../components/view/refund/BulkRefundGenerator/BulkRefundJSONGeneratorView';
import ActivityLogs from '../containers/ActivityLogContainer';
import SteppedPathways from '../containers/SteppedPathwaysContainer';
import ManualRetryView from '../components/view/ManualRetry/ManualRetryView';

const registeredViews = {
  [tabKeys.ACTIVITY_LOGS_KEY]: ActivityLogs,
  [tabKeys.CUSTOMER_PROFILE_KEY]: CustomerProfileView,
  [tabKeys.COMMUNICATION_PREFERENCES_KEY]: CommunicationPreferencesView,
  [tabKeys.LINK_CUSTOMER_ACCOUNTS_KEY]: LinkedCustomersView,
  [tabKeys.UNENROLL_SAML_USERS_KEY]: UnenrollSamlUsersView,
  [tabKeys.UPDATE_USERNAME_KEY]: UpdateUsernameView,
  [tabKeys.REMOVE_USER_KEY]: RemoveUserView,
  [tabKeys.CONVERSATION_VIEWER_KEY]: ConversationViewer,
  [tabKeys.STEPPED_PATHWAYS_KEY]: SteppedPathways,
  [tabKeys.COPY_DOCUMENTS_KEY]: CopyDocumentsView,
  [tabKeys.TRANSACTION_SEARCH_KEY]: TransactionSearchView,
  [tabKeys.SCHEDULED_TRANSACTION_SEARCH]: ScheduledTransactionView,
  [tabKeys.MANAGED_PAY_KEY]: ManagedPayView,
  [tabKeys.BULK_GEN_RESOLVE_KEY]: BulkGenResolveView,
  [tabKeys.BULK_REFUND_JSON_GENERATOR_KEY]: BulkRefundJSONGeneratorView,
  [tabKeys.AUTOPAY_KEY]: AutopayView,
  [tabKeys.AUTOPAY_STATUS_KEY]: AutopayStatus,
  [tabKeys.SEND_EMAIL_KEY]: SendEmailView,

  [tabKeys.SMS_SEARCH_KEY]: SMSSearchView,
  [tabKeys.REFUND_KEY]: RefundView,
  [tabKeys.NCDMV_KEY]: NcDmv,
  [tabKeys.KS_DMV_KEY]: KsDmv,
  [tabKeys.KS_DL_KEY]: KsDl,
  [tabKeys.KS_DL_COA_KEY]: KsDLCoA,
  [tabKeys.GR_WATER_KEY]: GRWater,
  [tabKeys.GR_WATER_V2_KEY]: GRWaterV2,
  [tabKeys.SERVICE_MANAGEMENT_KEY]: ServiceManagement,
  [tabKeys.GR_REFUSE_KEY]: GRRefuse,
  [tabKeys.BEAUFORT_KEY]: Beaufort,
  [tabKeys.KCK_TAX_KEY]: KCKTax,
  [tabKeys.KCK_TAX_PERSONAL_KEY]: KCKTaxPersonal,
  [tabKeys.JACKSON_KEY]: Jackson,
  [tabKeys.SHELBY_KEY]: Shelby,
  [tabKeys.GR_PARKING_KEY]: GRParking,
  [tabKeys.GR_BLOCK_GRANTS_KEY]: GRBlockGrants,
  [tabKeys.GR_PROPERTY_TAX_KEY]: GRPropertyTax,
  [tabKeys.ENCRYPT_DECRYPT_KEY]: EncryptDecrypt,
  [tabKeys.STL_PROPERTY_KEY]: STLProperty,
  [tabKeys.STL_WATER_KEY]: STLWater,
  [tabKeys.STL_REAL_ESTATE_KEY]: STLRealEstate,
  [tabKeys.FLORIDA_DMV_KEY]: FlDmv,

  [tabKeys.SERVICE_FEE_VIEW]: ServiceFee,
  [tabKeys.EBILL_CUSTOMER_VIEW]: EbillCustomerView,
  [tabKeys.EBILL_SEND]: EbillSend,
  [tabKeys.EBILL_TRIAL_SEND]: EbillTrialSend,
  [tabKeys.NCDL_KEY]: NcDl,
  [tabKeys.NCDMV_DRIVING_RECORD_KEY]: NcDmvDrivingRecord,
  [tabKeys.NCDMV_HEARING_FEE_KEY]: NcDmvHearingFee,
  [tabKeys.BEAUFORT_UNENROLLMENT_KEY]: BeaufortUnenrollment,
  [tabKeys.BATCH_PAY_KEY]: BatchPay,
  [tabKeys.IVR_KEY]: IVR,
  [tabKeys.OK_DMV_KEY]: OkDmv,
  [tabKeys.AVS_WHITELIST_KEY]: AVSWhitelist,
  [tabKeys.EBILLING]: EbillingView,
  [tabKeys.NC_INSURANCE_LAPSE_KEY]: NcInsuranceLapse,
  [tabKeys.NC_HF_LITES_KEY]: NcHFLites,
  [tabKeys.NC_HANDICAP_PLACARD]: NcDmvHandicapPlacard,
  [tabKeys.NC_IDENTITY_VERIFICATION]: NcIdentityVerification,
  [tabKeys.NCDMV_DRIVEWAY_PERMITS]: NcDmvDrivewayPermits,
  [tabKeys.NCDMV_CRASH_REPORTS]: NcDmvCrashReports,
  [tabKeys.NC_HF_AHS]: NcHFAHS,
  [tabKeys.NC_CP_AHS]: NcCPAHS,
  [tabKeys.PAYABLE_REMINDER_SERVICE_KEY]: PRSView,
  [tabKeys.QUEUE_ITEM_SEARCH]: FailedQueueItemSearchView,
  [tabKeys.MANUAL_RETRY_KEY]: ManualRetryView,
};

export default registeredViews;
